import { Injectable, inject } from '@angular/core';
import { DownloadTaskProgressService } from '../download-task-progress.service';

@Injectable({
  providedIn: 'root',
})
export class OfflineDataMockService {
  #downloadTaskProgressService = inject(DownloadTaskProgressService);

  public async downloadTask(selectedTask: { id: string; projectId: string; jobId: string; name: string }): Promise<void> {
    this.#downloadTaskProgressService.setProgressValueForTasks([selectedTask.id], 20);
    await this.timeout();
    this.#downloadTaskProgressService.setProgressValueForTasks([selectedTask.id], 40);
    await this.timeout();
    this.#downloadTaskProgressService.setProgressValueForTasks([selectedTask.id], 60);
    await this.timeout();
    this.#downloadTaskProgressService.setProgressValueForTasks([selectedTask.id], 80);
    await this.timeout();
    this.#downloadTaskProgressService.setProgressValueForTasks([selectedTask.id], 100);
  }

  public async exportDataBeforeUpdate(): Promise<void> {
    await this.timeout();
  }

  private timeout(): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, 1000));
  }
}
